import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useLoginSignUpUiConfiguration() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_LOGIN_SIGNUP_UI, {
    defaultValue: { hideFooterAndSecondaryButtonsOnKeyboardOpen: false },
  });
}
